import { Component, EventEmitter, OnInit } from '@angular/core';

import { ModalPopupService } from 'src/app/shared/services/modal-popup.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: 'confirmation.component.html',
  styleUrls: ['confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {
  data: string;
  loading: boolean;
  result = new EventEmitter();
  header: string;

  constructor(
    private modalPopupService: ModalPopupService,
  ) { }

  ngOnInit(): void {
  }

  close(): void {
    this.result.emit(false);
    this.modalPopupService.hideModal();
  }

  yes(): void {
    this.result.emit(true);
    this.modalPopupService.hideModal();
  }
}
